<script>
import PictureLazyMixin from '@phoenix/mixins/components/common/PictureLazyMixin';

export default {
  mixins: [PictureLazyMixin],
};
</script>

<template>
  <picture v-if="lazy">
    <source
      v-for="source in sources"
      :key="source.media"
      :media="source.media"
      :srcset="placeholder(source.width, source.height)"
      :data-srcset="source.srcset"
    />
    <img
      :src="placeholder(imgWidth, imgHeight)"
      :data-src="image.src"
      :data-srcset="image.srcset"
      :class="['lazyload', imgClass]"
      :alt="alt"
    />
  </picture>

  <picture v-else>
    <source v-for="source in sources" :key="source.media" :media="source.media" :srcset="source.srcset" />
    <img :src="image.src" :srcset="image.srcset" :class="imgClass" :alt="alt" />
  </picture>
</template>
